import { useGLTF } from '@react-three/drei';
import { Clone } from '@react-three/drei';
import { useState, useRef, useCallback, memo } from 'react';
import { Select } from '@react-three/postprocessing';
import clickSound from './click_Sound.mp3';
import { useModal } from '../../contexts/ModalContext';
import OtherProjects from '../billboard_components/OtherProjects';
import AboutMe from '../billboard_components/AboutMe';
import HCI from '../billboard_components/HCI';
import Phonici from '../billboard_components/Phonici';
import FieldStats from '../billboard_components/FieldStats';
import OneSmallStep from '../billboard_components/OneSmallStep';

const clickSoundInstance = new Audio(clickSound);
clickSoundInstance.volume = 0.5;

const Billboard = memo(function Billboard({ modelPath, position, scale, rotation, contentType, onSelect}) {
    const { scene } = useGLTF(modelPath);
    const [isHovered, setIsHovered] = useState(false);
    const cloneRef = useRef();
    const { openModal } = useModal();

    // Billboard click sound
    const playClickSound = () => {
        clickSoundInstance.currentTime = 0; 
        clickSoundInstance.play();
    }

    const getModalContent = () => {
        switch(contentType){
            case 'aboutMe':
                return { component: <AboutMe />, title: ""};
            case 'phonici':
                return { component: <Phonici />, title: ""};
            case 'hci':
                return { component: <HCI />, title: ""};
            case 'otherProjects':
                return { component: <OtherProjects />, title: ""};
            case 'fieldStats':
                return {component: <FieldStats />, title: ""};
            case 'oneSmallStep':
                return { component: <OneSmallStep />, title: ""}
            default:
                return { component: <div>Content Not Available</div>, title: "Billboard"};
        }
    };

    // Show Billboard UI when a billboard is clicked
    const handleClick = useCallback((e) => {
        e.stopPropagation();
        playClickSound();
        const { component, title } = getModalContent();
        openModal(component, title);
    }, [contentType, openModal]);

    // Add outline hover effect
    const handlePointerOver = useCallback((e) => {
        e.stopPropagation();
        setIsHovered(true);
        onSelect(e.object);
    }, [onSelect]);
    
    // Remove outline hover effect
    const handlePointerLeave = useCallback((e) => {
        e.stopPropagation();
        setIsHovered(false);
        onSelect(null);
    }, [onSelect]);

    return (
        <Select enabled={isHovered}>
            <Clone
                ref={cloneRef}
                onClick={handleClick}
                onPointerOver={handlePointerOver}
                onPointerOut={handlePointerLeave}
                object={scene}
                scale={scale}
                position={position}
                rotation={rotation}
            />
        </Select>
    );
})

export default Billboard;